import './travel-teaser-module.scss';

import Swiper from 'swiper';
import { A11y, Navigation, Keyboard } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';

class TravelTeaserModule {
    constructor (element) {
        this.$slider = element;
        this.slider = null;
    }

    initialize () {
        this.initSlider();
    }

    initSlider () {
        this.slider = new Swiper(this.$slider, {
            modules: [Navigation, A11y, Keyboard],
            slidesPerView: 'auto',
            speed: 500,
            keyboard: true,
            a11y: {
                prevSlideMessage: window.translations.slider.prevSlideMessage,
                nextSlideMessage: window.translations.slider.nextSlideMessage,
                paginationBulletMessage: window.translations.slider.paginationBulletMessage,
                firstSlideMessage: window.translations.slider.firstSlideMessage,
                lastSlideMessage: window.translations.slider.lastSlideMessage,
                slideLabelMessage: window.translations.slider.slideLabelMessage
            },
            navigation: {
                nextEl: this.$slider.querySelector('.swiper-button-next'),
                prevEl: this.$slider.querySelector('.swiper-button-prev')
            }
        });
    }
}

export { TravelTeaserModule };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$sliders = $context.querySelectorAll('[data-travel-teaser-module="slider"]');

        $$sliders.forEach(($slider) => {
            const travelTeaserModule = new TravelTeaserModule($slider);
            travelTeaserModule.initialize();
        });
    }
});
